import { useTranslation } from "react-i18next";
import { DetailProductFeaturesInfo } from "../type";

const DetailProductFeature = (prop: DetailProductFeaturesInfo) => {
    const {t} = useTranslation();
    return (
        <div className="p-6 space-y-6 store-container">
            <div>
                <h3 className="!text-lg font-semibold text-gray-900 mb-3">{t('store_detail_mainFeature')}</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {prop.mainFeature.map((feature) => (
                        <div
                            key={feature}
                            className="flex items-start gap-3 p-3 bg-gray-50 rounded-lg"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="lucide lucide-zap h-5 w-5 text-green-500 mt-0.5 flex-shrink-0"
                            >
                                <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
                            </svg>
                            <span className="text-gray-700">{feature}</span>
                        </div>
                    ))}
                </div>
            </div>
            <div className="store-container">
                <h3 className="!text-lg font-semibold text-gray-900 mb-3">{t('store_detail_detailFeature')}</h3>
                <div dangerouslySetInnerHTML={{ __html: prop.detail }} className="prose prose-sm max-w-none detail-feature-tab-text"></div>
            </div>
        </div>
    );
};

export default DetailProductFeature;